import React from 'react';
import Question from '../../../interfaces/question';
import { ChosenOptionAnswer } from '../../context/SurveyPageContext';
import { COLOR_BREAK_POINT, getBrightness } from '../../../utils/colors';

import styles from './RadioColor.module.css';

export interface RadioColorProps {
  question: Question;
  onChange: (newValue: number) => void;
  radioButtonAnswer: ChosenOptionAnswer | undefined;
}

const RadioColor: React.FunctionComponent<RadioColorProps> = ({
  question,
  onChange,
  radioButtonAnswer,
}) => {
  const { id: questionId } = question;
  const radioOptionId = radioButtonAnswer?.chosenOption?.id;

  return (
    <div className={styles.radioColorContainer}>
      {question.radioButtonOptions.map((option) => {
        const fontColor = getBrightness(option.description) > COLOR_BREAK_POINT ? 'black' : 'white';

        return (
          <label htmlFor={`${option.id}`} key={`label-${questionId}-${option.id}`}>
            <input
              className={styles.radioColorInput}
              type="radio"
              id={`${option.id}`}
              key={`input-${questionId}-${option.id}`}
              name={`${questionId}`}
              onChange={() => onChange(option.id)}
              checked={radioOptionId === option.id}
              style={{ backgroundColor: option.description }}
              data-testid={`question-skin-tone-radio-${option.id}`}
            />
            <span className={`${styles.explanation} ${styles[fontColor]}`}>
              {option.explanation}
            </span>
          </label>
        );
      })}
    </div>
  );
};

RadioColor.displayName = 'RadioColor';

export default RadioColor;
